import React from 'react'
import './videoSlider.scss'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import Vimeo from '@u-wave/react-vimeo';
import 'swiper/css';
import "swiper/css/navigation";


const Slider = ({classNames='', videos}) => {
    const classes=`video-slider ${classNames}`
    return (
        <div className={classes}>
            <Swiper
            modules={[Navigation]}
            slidesPerView={1}
            disableOnInteraction={false}
            loop
            navigation={true}
            >
                {videos.map(video => {
                    return <SwiperSlide><Vimeo className="video" video={video.vimeo_id} /></SwiperSlide>
                })}
            </Swiper>
        </div>
    )
}

export default Slider